package com.isaias.fyattravel.web.layout

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.isaias.fyattravel.web.i18n.WebStringKey
import com.isaias.fyattravel.web.i18n.WebStrings
import com.isaias.fyattravel.web.theme.ThemeColors

/**
 * Page header with title and refresh button
 */
@Composable
fun PageHeaderRow(
    title: String,
    lastUpdatedMs: Double?,
    onRefresh: () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.SpaceBetween)
            marginTop(0.5.em)
            marginBottom(1.em)
        }
    }) {
        H1({
            style {
                fontSize(2.0.em)
                fontWeight("900")
                margin(0.px)
                color(ThemeColors.textPrimary)
            }
        }) { Text(title) }

        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                gap(0.75.em)
            }
        }) {
            if (lastUpdatedMs != null) {
                val label = try {
                    js("new Date(lastUpdatedMs).toLocaleTimeString()") as String
                } catch (_: dynamic) {
                    ""
                }
                if (label.isNotBlank()) {
                    Span({ style { color(ThemeColors.textMuted); fontSize(0.9.em) } }) {
                        Text(WebStrings.format(WebStringKey.UPDATED_AT, label))
                    }
                }
            }

            Button(attrs = {
                style {
                    backgroundColor(ThemeColors.surface)
                    color(ThemeColors.textPrimary)
                    padding(0.6.em, 0.95.em)
                    borderRadius(0.75.em)
                    property("border", "1px solid ${ThemeColors.divider}")
                    cursor("pointer")
                    fontWeight("800")
                }
                onClick { onRefresh() }
            }) { Text(WebStrings.t(WebStringKey.REFRESH)) }
        }
    }
}

/**
 * Placeholder page for unfinished features
 */
@Composable
fun PlaceholderPage(title: String, subtitle: String) {
    H1({
        style {
            fontSize(2.2.em)
            fontWeight("800")
            marginBottom(0.4.em)
            color(ThemeColors.textPrimary)
        }
    }) { Text(title) }

    P({
        style {
            fontSize(1.05.em)
            color(ThemeColors.textMuted)
            marginBottom(1.25.em)
        }
    }) { Text(subtitle) }
}
